<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<div class="pre" id="pre-001"><span epub:type="pagebreak" id="page_IX" role="doc-pagebreak" title="IX">
<h1 class="pre_tit" epub:type="title"><span>Figures</span></h1>
<div class="enc">
<div class="dev">
<p class="txt_courant_ssalinea retrait_gauche"><a class="renv" href="#/chap1#fig-080">1.1 Methodological Decisions</a></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap2#fig-069" title="Link target outside of Sample">2.1 Syncopation with Rest</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap2#fig-070" title="Link target outside of Sample">2.2 Syncopation with Tie</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap3#fig-072" title="Link target outside of Sample">3.1 The Metrical Matrix</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap3#fig-074" title="Link target outside of Sample">3.2 Final Cadence in Sonata Form</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap4#fig-075" title="Link target outside of Sample">4.1 Authentic Cadence in the Key of C</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap4#fig-076" title="Link target outside of Sample">4.2 Plagal Cadence in the Key of C</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap4#fig-077" title="Link target outside of Sample">4.3 Deceptive Cadence in the Key of C</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap4#fig-078" title="Link target outside of Sample">4.4 Half Cadence in the Key of C</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap4#fig-082" title="Link target outside of Sample">4.5 Anticipation in the Key of F</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span class="renv" href="#/chap4#fig-083" title="Link target outside of Sample">4.6 Suspension in the Key of F</span></p>
<p class="txt_courant_ssalinea retrait_gauche"><span epub:type="pagebreak" id="page_X" role="doc-pagebreak" title="X"><span class="renv" href="#/chap4#fig-079" title="Link target outside of Sample">4.7 Eugene Lowry’s Revised Homiletical Plot</span></span></p>
</div>
</div>
</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre2.vue?7c025870